<div class="modal z-50 fixed w-screen h-full top-0 left-0 flex items-center justify-center p-5 lg:p-0">
  <div class="modal-overlay fixed w-full h-full bg-gray-900 opacity-50"></div>
  <div class="bg-white w-full lg:max-w-screen-lg mx-auto rounded-lg shadow-xl z-50 overflow-y-auto">
    <!-- style="height: 50vh" -->
    <div class="flex flex-col gap-3 lg:justify-between lg:flex-row">
      <!-- Formulário -->
      <div class="w-full p-5">
        <form class="" [formGroup]="formEditDoctor">
          <div class="grid w-full grid-cols-2 gap-4">
            <div class="form-group">
              <label for="name" class="input-label">Nome*</label>
              <input type="text" class="form-input" formControlName="name" id="name" />
            </div>

            <div class="form-group">
              <label for="cpf" class="input-label">CPF*</label>
              <input
                type="text"
                class="form-input"
                formControlName="document"
                [showMaskTyped]="true"
                id="cpf"
                mask="000.000.000-00"
              />
            </div>

            <div class="form-group">
              <label for="email" class="input-label">E-mail*</label>
              <input type="email" class="form-input" formControlName="email" id="email" />
            </div>

            <div class="form-group">
              <label for="phone" class="input-label">Celular*</label>
              <input type="text" class="form-input" formControlName="phone" id="phone" mask="(00) 00000-0000" />
            </div>

            <div class="form-group">
              <label for="crm" class="input-label">CRM*</label>
              <input type="text" class="form-input" formControlName="crm" id="crm" mask="0*" />
            </div>

            <div class="form-group">
              <label for="comments" class="input-label">Comentários</label>
              <input type="text" class="form-input" formControlName="comments" id="comments" />
            </div>
          </div>

          <div class="flex mt-3 flex-col overflow-y-auto" style="height: 300px">
            <ng-container *ngFor="let formControl of formArrayCompanies.controls; let companyIndex = index">
              <app-doctor-details
                [opcoesCompany]="opcoesCompany"
                [form]="formControl"
                (removerEmpresa)="removerEmpresa(companyIndex)"
              >
              </app-doctor-details>
            </ng-container>
          </div>

          <div class="flex flex-row justify-center" *ngIf="podeAdicionarEmpresa">
            <button
              *isAllowed="[ERoleAdminString.Admin, 'doctor.update']"
              class="sm:px-2 lg:my-5 btn btn--secondary"
              (click)="adicionarEmpresa()"
            >
              Adicionar Médico a Empresa
            </button>
          </div>
        </form>
      </div>

      <!-- Menu Lateral -->
      <div
        class="relative flex flex-row justify-between gap-5 p-3 lg:px-10 sm:justify-start sm:gap-3 sm:flex-wrap lg:flex-col lg:justify-end bg-iceberg menu lg:h-auto sm:w-auto"
      >
        <button class="absolute w-12 h-10 rounded-sm lg:top-5 right-10 btn--secondary" routerLink="/dash/medicos">
          X
        </button>
        <ng-container *isAllowed="[ERoleAdminString.Admin, 'doctor.disable']">
          <button *ngIf="isDoctorActive" class="sm:px-2 btn btn--secondary" (click)="desativarMedico()">
            Desativar Médico
          </button>
        </ng-container>
        <ng-container *isAllowed="[ERoleAdminString.Admin, 'doctor.enable']">
          <button *ngIf="!isDoctorActive" class="sm:px-2 btn btn--secondary" (click)="ativarMedico()">
            Ativar Atendente
          </button>
        </ng-container>

        <button
          *isAllowed="[ERoleAdminString.Admin, 'doctor.update']"
          class="sm:px-2 lg:mb-5 btn btn--secondary"
          (click)="editarMedico()"
        >
          Salvar Cadastro
        </button>
      </div>
    </div>
  </div>
</div>
